import { useEffect } from 'react';

import { Table } from '@playbooks/ui/components/table';

export const TableElement = props => {
	// Hooks
	useEffect(() => {
		// logger.log('TableElement: ', props);
	}, []);

	// Render
	return (
		<div className='border rounded-control mb-8'>
			<Table {...props} />
		</div>
	);
};
